/**
 * @flow
 */

import React, { Component } from 'react'
import MapDescriptionSection from './MapDescriptionSection'
import { MapSectionContainer, MapBackground } from './styledComponents'

class MapSection extends Component {
  static defaultProps = {
    isSuper30Page: false
  }

  render() {
    const { amanoraSectionDetails, isSuper30Page, isNewArcadePage } = this.props
    const {
      heading: amonaraSectionHeading,
      description: amonaraSectionDescription,
      addressHeading,
      address,
      landmarkHeading,
      landmark,
      contactNoHeading,
      contactNumber,
      arcadeMapUrl
    } = amanoraSectionDetails
    const GOOGLE_MAP_EMBED_URL = `${arcadeMapUrl}&disable_scroll=true&t=m`

    return (
      <MapSectionContainer
        id={`arcade-map-section`}
        isNewArcadePage={isNewArcadePage}
      >
        <MapDescriptionSection
          amonaraSectionHeading={amonaraSectionHeading}
          amonaraSectionDescription={amonaraSectionDescription}
          addressHeading={addressHeading}
          address={address}
          landmarkHeading={landmarkHeading}
          landmark={landmark}
          contactNoHeading={contactNoHeading}
          contactNumber={contactNumber}
          isSuper30Page={isSuper30Page}
        />
        <MapBackground
          title="Arcade Map Location"
          src={GOOGLE_MAP_EMBED_URL}
          frameBorder={0}
          marginHeight={0}
          marginWidth={0}
          className="lazyload"
        />
      </MapSectionContainer>
    )
  }
}

export default MapSection

/*
maps url parameters info: https://doc.arcgis.com/en/arcgis-online/reference/embed-map-parameters.htm
*/



// WEBPACK FOOTER //
// ./src/components/IbcArcade/MapSection/index.js